import { SearchBoxState, StandaloneSearchBoxState } from '@coveo/headless';
import { IconSearch, IconClose } from '@lmig/lmds-react-icons';
import { SearchInput } from '@lmig/lmds-react-alphanumeric-input';
import { ClickAwayListener } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { isOneBrand, isPL } from 'Foundation/Configurations/GlobalConfiguration';
import { Button } from '@lmig/lmds-react-button';

interface ISearchSuggestionInput {
  label: string;
  state: StandaloneSearchBoxState | SearchBoxState;
  onChange: Function;
  onSubmit: Function;
  onSuggestionClick: Function;
  showSuggestions?: boolean;
  showSearch?: boolean;
  onOpen?: (isOpen: boolean) => void;
}
export function SearchSuggestionInputSlideout({
  state,
  onChange,
  onSubmit,
  onSuggestionClick,
  showSuggestions = true,
  label,
  showSearch,
  onOpen,
}: ISearchSuggestionInput) {
  const [suggestionsVisible, setSuggestionsVisible] = useState(true);
  const [open, setOpen] = useState(false);
  const searchInputRef = useRef<HTMLInputElement>(null);
  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      submitSearch();
    }
  };
  const iconClick = () => {
    if (!open) {
      setOpen(true);
    }
  };
  const closeSearch = () => {
    if (open) {
      setOpen(false);
    }
  };
  const submitSearch = () => {
    if (state.value !== '') {
      setSuggestionsVisible(false);
      onSubmit();
    } else {
      searchInputRef.current?.select();
    }
  };
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (open) {
      searchInputRef.current?.select();
      inputRef?.current?.focus();
    } else {
    }
    if (onOpen) onOpen(open);
  }, [open]);
  return (
    <>
      <ClickAwayListener
        touchEvent={false}
        onClickAway={() => {
          setOpen(false);
        }}
      >
        <div id="search-input-parent-container">
          {(open || showSearch) && (
            <div className="search-input-suggestion-wrapper">
              <SearchInput
                title={label}
                labelVisual={label}
                aria-label={label}
                aria-live="polite"
                value={state.value}
                onChange={(e) => onChange(e.target.value)}
                onKeyDown={(e) => onKeyDown(e)}
                onFocus={() => setSuggestionsVisible(true)}
                onBlur={() => setSuggestionsVisible(false)}
                onClearClicked={() => onChange('')}
                innerRef={inputRef}
              />
              {showSuggestions && suggestionsVisible && state.suggestions.length > 0 && state.value.length !== 0 && (
                <div className="search-suggest" role="listbox">
                  <div className="search-suggest-content">
                    <ul className="search-suggest-list">
                      {state.suggestions.map((suggestion) => {
                        const value = suggestion.rawValue;
                        return (
                          <li
                            key={value}
                            onMouseDown={() => onSuggestionClick(value)}
                            className="search-suggest-list-item"
                            aria-label={typeof suggestion === 'object' ? suggestion.rawValue : suggestion}
                          >
                            {value}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          )}
          {!open && (
            <>
              {/* hidden by css breakpoint if < 960px wide */}
              <div onClick={iconClick} className="search-icon-button desktop-header">
                <IconSearch title="Search" color={isPL() && !isOneBrand() ? 'inverse' : 'blue'} size="16" />
                <p id="search-text">Search</p>
              </div>
            </>
          )}
          {open && (
            <>
              <Button id="search-button" variant="secondary" size="large" target="_blank" onClick={submitSearch}>
                Search
              </Button>

              {isPL() ? (
                <>
                  <IconClose
                    size="16"
                    color={isOneBrand() ? "blue" : "inverse"}
                    onClick={closeSearch}
                    className="icon-close-search desktop-header"
                  />
                  <p onClick={closeSearch} style={!isOneBrand() ? { color: 'white' } : undefined}>
                    Close Search
                  </p>
                  <div className="desktop-header separator-navbar-pl"></div>
                </>
              ) : (
                <>
                  <IconClose
                    size="16"
                    color="blue"
                    onClick={closeSearch}
                    className="icon-close-search desktop-header"
                  />
                  <p onClick={closeSearch} style={{ color: 'bg-liberty-blue' }}>
                    Close Search
                  </p>
                  <div className="desktop-header separator-navbar-bl"></div>
                </>
              )}
            </>
          )}
        </div>
      </ClickAwayListener>
    </>
  );
}
